export default __webpack_public_path__ + "static/media/close.2fce6214.png";